/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'confluence-analytics-byline.abbreviated-user-views.message':
    '{count, plural, =0 {Visualizaciones} one {{1}} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Visores',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Análisis} one {Visto por 1 persona} other {Visto por {count} personas}}',
};
